import { useMutation } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	CreatePaymentVerificationMutation,
	CreatePaymentVerificationMutationVariables,
} from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	mutation CreatePaymentVerification($input: CreatePaymentVerificationInput!) {
		createPaymentVerification(input: $input) {
			_id
		}
	}
`;

export type CreatePaymentVerificationVariables =
	CreatePaymentVerificationMutationVariables;
export type CreatePaymentVerificationResults =
	CreatePaymentVerificationMutation["createPaymentVerification"];

export const useCreatePaymentVerification = () => {
	return useMutation({
		mutationFn: (variables: CreatePaymentVerificationVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.createPaymentVerification),
	});
};
